export default __webpack_public_path__ + "static/media/clothingstore.6e936931.png";